<section class="contact-page p-3 d-flex flex-column gap-2">
  <header class="contact-header px-1 px-md-2">
    <h2 class="title mb-2">¿Necesitas ayuda?</h2>
    @if (sendRequestsEnabled()) {
      <p class="contact-intro mb-0">
        Si tienes cualquier duda o necesitas realizar una gestión, envíanos una consulta. Nuestro
        equipo la recibirá y te responderá lo antes posible.
      </p>
    } @else {
      <p class="contact-intro mb-0">
        Si tienes cualquier duda o necesitas realizar una gestión, puedes contactar con nosotros a
        través de los siguientes canales.
      </p>
    }
  </header>

  @if (sendRequestsEnabled()) {
    <p-card styleClass="contact-hero-card">
      <div class="contact-hero">
        <div class="contact-hero-orb" aria-hidden="true">
          <lucide-icon name="MessageSquareMore" [strokeWidth]="2" [size]="32"></lucide-icon>
        </div>
        <h3 class="contact-hero-title">Enviar una consulta</h3>
        <p class="contact-hero-desc mb-3">
          Es la forma más rápida de contactar con nosotros. Tu solicitud quedará registrada y
          podremos hacer un seguimiento hasta su resolución.
        </p>
        <p-button
          label="Enviar consulta"
          icon="pi pi-send"
          severity="primary"
          size="large"
          styleClass="contact-hero-cta"
          (onClick)="goToSendConsultation()"
        />
        <p class="contact-hero-note mt-3 mb-0">
          Te responderemos por correo electrónico lo antes posible.
        </p>
      </div>
    </p-card>
  }

  @if (contact()?.phone || contact()?.email || contact()?.web) {
    <p-card styleClass="contact-alt-card">
      @if (sendRequestsEnabled()) {
        <h3 class="contact-alt-title">¿No puedes utilizar el formulario?</h3>
        <p class="contact-alt-desc">
          Si tienes problemas para enviar una consulta, también puedes contactar con nosotros
          mediante:
        </p>
      } @else {
        <h3 class="contact-alt-title">Datos de contacto</h3>
        <p class="contact-alt-desc">Puedes contactar con nosotros mediante:</p>
      }

      <ul class="contact-alt-list list-unstyled mb-0">
        @if (contact()?.phone; as phone) {
          <li>
            <a class="contact-alt-link" [href]="telHref(phone)">
              <i class="pi pi-phone" aria-hidden="true"></i>
              <span>{{ displayPhone() }}</span>
            </a>
          </li>
        }
        @if (contact()?.email; as email) {
          <li>
            <a class="contact-alt-link" [href]="'mailto:' + email">
              <i class="pi pi-envelope" aria-hidden="true"></i>
              <span>{{ email }}</span>
            </a>
          </li>
        }
      </ul>

      @if (contact()?.web; as web) {
        <a class="contact-alt-web" [href]="web" target="_blank" rel="noopener noreferrer">
          <i class="pi pi-globe" aria-hidden="true"></i>
          <span>{{ web }}</span>
        </a>
      }

      @if (isGGM()) {
        <div class="contact-schedule-block">
          <h4 class="contact-schedule-title">Horario de atención</h4>
          <dl class="contact-schedule mb-0">
            <div class="contact-schedule-row">
              <dt>Lunes a jueves</dt>
              <dd>08:00 – 17:00</dd>
            </div>
            <div class="contact-schedule-row">
              <dt>Viernes</dt>
              <dd>08:00 – 13:30</dd>
            </div>
          </dl>
        </div>

        @if (sendRequestsEnabled()) {
          <p class="contact-alt-hint mb-0">
            Recomendamos utilizar el formulario para agilizar la gestión de tu solicitud.
          </p>
        }
      }
    </p-card>
  } @else if (isGGM()) {
    <p-card styleClass="contact-alt-card">
      <div class="contact-schedule-block contact-schedule-block--solo">
        <h4 class="contact-schedule-title">Horario de atención</h4>
        <dl class="contact-schedule mb-0">
          <div class="contact-schedule-row">
            <dt>Lunes a jueves</dt>
            <dd>08:00 – 17:00</dd>
          </div>
          <div class="contact-schedule-row">
            <dt>Viernes</dt>
            <dd>08:00 – 13:30</dd>
          </div>
        </dl>
      </div>
    </p-card>
  }

  @if (socialLinks().length > 0) {
    <nav class="contact-social" aria-label="Redes sociales">
      <p class="contact-social-label mb-2">Síguenos</p>
      <div class="contact-social-row">
        @for (item of socialLinks(); track item.link) {
          <a
            class="contact-social-orb"
            [href]="item.link"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="item.name"
            [attr.title]="item.name"
          >
            <i [class]="item.iconClass" aria-hidden="true"></i>
          </a>
        }
      </div>
    </nav>
  }
</section>
